
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {

  1: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P69-E1',
    audio: 'img/FriendsPlus/Page69/Audio/audio-e1-p69.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page69/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page69/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page69/Audio/tieude-e1-p69.mp3' },
        { url: 'img/FriendsPlus/Page69/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page69/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page69/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/6.jpg', input: true, answer: "biggest" },
        { url: 'img/FriendsPlus/Page69/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/8.jpg', input: true, answer: "lake" },
        { url: 'img/FriendsPlus/Page69/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page69/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/11.jpg', input: true, answer: "longest" },
        { url: 'img/FriendsPlus/Page69/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/13.jpg', input: true, answer: "beach" },
        { url: 'img/FriendsPlus/Page69/E1/14.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page69/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/16.jpg', input: true, answer: "largest " },
        { url: 'img/FriendsPlus/Page69/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page69/E1/18.jpg', input: true, answer: "island" },
        { url: 'img/FriendsPlus/Page69/E1/19.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page69/E1/20.jpg' },
      ],

    ],
  },

  2: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P69-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    exerciseKey: '',
    questionImage: [ // Row      
      [
        // Column1
        { url: 'img/FriendsPlus/Page69/E2/1.jpg' },

      ]
    ],
  },
  3: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P69-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    exerciseKey: 'img/FriendsPlus/Page69/E3/Key/answerKey.png',
    totalInput: 5,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page69/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page69/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page69/E3/3.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page69/E3/4.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page69/E3/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page69/E3/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page69/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page69/E3/8.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page69/E3/9.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page69/E3/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page69/E3/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page69/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page69/E3/13.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page69/E3/14.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page69/E3/15.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page69/E3/16.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page69/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page69/E3/18.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page69/E3/19.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page69/E3/20.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page69/E3/21.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page69/E3/22.jpg' },
        { url: 'img/FriendsPlus/Page69/E3/23.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page69/E3/24.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page69/E3/25.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page69/E3/26.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page69/E3/27.jpg' },
      ],



    ],
  },
  4: { // Exercise num
    unit: 'Unit 9',
    id: 'SB4-U9-P69-E4',
    audio: '',
    video: '',
    hideBtnFooter: true,
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page69/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page69/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page69/E4/2.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page69/E4/3.jpg' },
        { url: 'img/FriendsPlus/Page69/E4/4.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page69/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page69/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page69/E4/7.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page69/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page69/E4/9.jpg', input: true, answer: "" },
        { url: 'img/FriendsPlus/Page69/E4/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page69/E4/11.jpg' },
      ],


    ],
  },


}
export default json;
